
<!-- Home Section -->
<section id="home" class="container-fluid home-Section">
  <div class="container content-main text-center">
    <h2 class="main-text">We Make Organizations More Innovative & Agile</h2>
    <!--    <h2 class="main-text">Fighting Covid-19: We are at the forefront</h2>-->
    <!--    <p class="text-center text-white" style=""><a style="text-decoration: none;color: white" routerLink="/insights/fighting-covid-19-we-are-at-the-forefront">Find out more...</a></p>-->
  </div>
</section>
<!-- Portfolio Section -->
<section id="portfolio" class="container-fluid portfolio-Section">
  <div class="container">
    <div class="row">
      <div class="col-12 text-center">
<!--        <h2 class="pt-5 mb-3"><b>Our Portfolio</b></h2>-->
        <p>IrvineTek has successfully designed, developed and launched several web and mobile applications. We have also helped
          startups in project discovery and assisted established businesses in digitization and technological transformation.
          Below is a brief list of our projects:</p>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-12 col-12 chs-text">
        <h2 class="pt-5 mb-3"><b>Camden Health System</b></h2>
        <p>Web & Mobile Health ERP</p>
        <p>Tech Stack: Python, Angular, React Native, PostGreSQL</p>
        <p>Designed & developed by IrvineTek, Camden Health System is the
          premium hospital management information system that provides
          clinical & non-clinical services. It is currently used by several public and
          private sectors hospitals & thousand of healthcare staff members.
          CHS offers 20+ specialized healthcare modules in following categories:</p>
        <ul class="pl-4">
          <li><strong>Clinical</strong></li>
          <li><strong>Diagnostics</strong></li>
          <li><strong>Administration</strong></li>
          <li><strong>Financials</strong></li>
          <li><strong>Analytics</strong></li>
        </ul>
        <p>More information can be found at <a href="https://camdenhealthsys.com/" target="_blank">www.camdenhealthsys.com</a></p>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-12 d-flex align-items-center">
        <img src="assets/images/healthcare.png" class="img-fluid" alt="Portfolio">
      </div>
    </div>
  </div>
</section>
<!-- Twidlee Section -->
<section id="twidlee" class="container-fluid twidlee-Section">
  <div class="container py-5">
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-12 col-12 d-flex align-items-center display-web">
         <img src="assets/images/IrvineTek - Twidlee.png" class="img-fluid" alt="Twidlee" style="max-height: 400px;margin: auto">
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-12 d-flex align-items-center">
        <div class="">
          <h2 class="mb-3"><b>Twidlee</b></h2>
          <p>Flash Food Deals App (Android, iOS, Web)</p>
          <p>Tech stack: Python, React, PostGreSQL</p>
          <p>Twidlee is a flash food deals app for restaurants to offer same day dine in &
            take away deals. Restaurants use the app to post same day discounts and
            customers redeem these offers. There is also a comprehensive dashboard for
            restaurants as well as for administration.</p>
          <p>Restaurants can offer deals either via hybrid mobile app or by using web.
            They can also post pics, edit menu and even give and control access to the
            managers and servers.</p>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-12 d-flex align-items-center display-mobile">
        <img src="assets/images/IrvineTek - Twidlee.png" class="img-fluid" alt="Twidlee" style="max-height: 400px;margin: auto">
      </div>
    </div>
  </div>
</section>
<!-- Planet Hiring Section -->
<section id="planet-hiring" class="container-fluid planet-hiring-Section">
  <div class="container py-5">
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-12 col-12">
        <h2 class="mb-3"><b>Planet Hiring</b></h2>
        <p>AI based Interview</p>
        <p>Tech stack: Python, React, PostGreSQL</p>
        <p>Designed and developed by IrivneTek for a private client, Planet Hiring is AI
          based platform that assists organization in hiring right candidates.
          Companies only select candidates and interview profile and planet hiring
          does the rest i.e. interview scheduling, recording and assessment.</p>
        <p>Platform offers convenience and transparency. It also provides other
          features such as collaboration between different hiring managers to share
          profiles, re-watch interview recordings and add their own assessments.
        </p>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-12 d-flex align-items-center">
        <img src="assets/images/IrvineTek - PlanetHiring.png" class="img-fluid" alt="Planet Hiring">
      </div>
    </div>
  </div>
</section>
<!-- Help Are Us Section -->
<section id="helpAreUs" class="container-fluid help-are-us-Section">
  <div class="container py-5">
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-12 col-12 d-flex align-items-center display-web">
        <img src="assets/images/IrvineTek - HelpAreUs.png" class="img-fluid" alt="Help Are Us">
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-12">
        <h2 class="mb-3"><b>HelpAreUs</b></h2>
        <p>E-commerce web application</p>
        <p>Tech stack: Python, React, PostreSQL</p>
        <p>A User Interface and User Experience web developer is responsible for
          Designed and developed by IrivneTek, HelpAreUs is the e-commerce
          platform for every day items that are used for donation purposes.</p>
        <p>Website not only provides excellent user experience but it also have key
          back office features such as inventory management, tracking and alerts.</p>
        <p>Website is set to launch in Dec 2021.</p>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-12 d-flex align-items-center display-mobile">
        <img src="assets/images/IrvineTek - HelpAreUs.png" class="img-fluid" alt="Help Are Us">
      </div>
    </div>
  </div>
</section>
<!-- Star Bytes Section -->
<section id="star-byte-hiring" class="container-fluid star-byte-Section">
  <div class="container py-5">
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-12 col-12 d-flex align-items-center">
        <div class="">
          <h2 class="mb-3"><b>StarBytes</b></h2>
          <p>Entertainment mobile & web app</p>
          <p>Tech stack: Python, Angular, React JS</p>
          <p>The project has been designed and developed by IrivneTek for a private
            client. The app provides access to users to request personalized
            messages from their favorite celebrities.</p>
          <p>StarBytes development work includes mobile app for users and
            celebrities with feature for celebrities to record message and share
            them, all from the app. Complete discovery, wireframing and GUI was
            developed for the city of Los Angeles.</p>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-12 d-flex align-items-center">
        <img src="assets/images/IrvineTek%20-%20StarBytes%20-%20Web%20app.jpg" class="img-fluid" alt="Planet Hiring" style="max-height: 400px;margin: auto">
      </div>
    </div>
  </div>
</section>
<!-- Los Angeles Section -->
<section id="losAngeles" class="container-fluid los-angeles-Section">
  <div class="container py-5">
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-12 col-12 d-flex align-items-center display-web">
        <img src="assets/images/IrvineTek - Los Angeles.png" class="img-fluid" alt="Los Angeles" style="max-height: 400px;margin: auto">
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-12 d-flex align-items-center">
        <div>
          <h2 class="mb-3"><b>Experience Los Angeles</b></h2>
          <p>Tourist Service App</p>
          <p>Tech stack: Sketch</p>
          <p>Complete discovery, wireframing and GUI was developed for tourists
            and local businesses (including entertainment industry) for the city of
            Los Angeles.</p>
          <p>Application featured complete administrative access to add businesses
            & categories (entertainment, shopping, sight-seeing, . It also enabled
            entertainment and tourism related companies to offer packages and
            share upcoming events with the visitors.</p>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-12 d-flex align-items-center display-mobile">
        <img src="assets/images/IrvineTek - Los Angeles.png" class="img-fluid" alt="Los Angeles" style="max-height: 400px;margin: auto">
      </div>
    </div>
  </div>
</section>
<!-- Vunova Section -->
<section id="Vunova" class="container-fluid vunova-Section">
  <div class="container py-5">
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-12 col-12 d-flex align-items-center">
        <div class="">
          <h2 class="mb-3"><b>Vunova</b></h2>
          <p>Ed-Tech market place</p>
          <p>Tech stack: Ruby on Rails, Angular, MySQL</p>
          <p>Millions of local and international students seeks college admission
            related services every year. Vunova is a platform for college admission
            councilors and test-prep centers to showcase their services. Students
            and their parents can view profiles & ratings of service providers,
            connect with them and seek guidance.</p>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-12 d-flex align-items-center">
        <img src="assets/images/IrvineTek - Vunova.jpg" class="img-fluid" alt="Planet Hiring">
      </div>
    </div>
  </div>
</section>
<!-- Cheel Deal Section -->
<section id="cheelDeal" class="container-fluid cheel-deal-Section">
  <div class="container py-5">
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-12 col-12 d-flex align-items-center display-web">
        <img src="assets/images/IrvineTek - CheelDeal.png" class="img-fluid" alt="Los Angeles" style="max-height: 400px;margin: auto">
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-12 d-flex align-items-center">
        <div>
          <h2  class="mb-3"><b>Cheel Deal</b></h2>
          <p>Retail market place</p>
          <p>Tech stack: Adobe XD, React Native</p>
          <p>Complete discovery, wireframing and GUI was developed a tech startup.
            The app was designed for retailers to offer their excess inventory at
            reduced prices to the consumers.</p>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-12 d-flex align-items-center display-mobile">
        <img src="assets/images/IrvineTek - CheelDeal.png" class="img-fluid" alt="Los Angeles" style="max-height: 400px;margin: auto">
      </div>
    </div>
  </div>
</section>
